// sep-2026 · Sellado de condiciones de la solicitud (SOFOM). Espejo en pantalla del candado
// real, que vive en el backend (`sellado_solicitud.py`: PUT a un campo sellado = 403).
// Al pulsar «Enviar al Comité» estas condiciones quedan selladas: el Comité aprueba o
// rechaza, nadie las modifica. Para cambiar montos: cancelar y capturar una solicitud nueva.
// Las claves son las del FORMULARIO (`lib/nav.js` → solicitudes.fields).
// oct-2026 · `monto_autorizado` salió de esta lista porque salió del formulario: lo fija el
// Comité al decidir. Sigue sellado en el backend (nadie lo edita por `PUT /solicitudes`).
export const CAMPOS_SELLADOS = [
  "cliente", "producto_id", "monto_solicitado", "plazo",
  "periodicidad", "tasa_ordinaria", "tasa_moratoria", "comision_apertura",
  "comision_apertura_tipo_readonly", "iva",
];

//: Estatus en los que la solicitud espera decisión del Comité (igual que el backend).
export const ESTATUS_PENDIENTES = ["Prospecto", "Captura", "En análisis"];

//: Estatus que sellan la solicitud AUNQUE no exista el sello del envío (solicitudes
//: anteriores al botón «Enviar al Comité»). Igual que `sellado_solicitud.ESTATUS_SELLADOS`.
export const ESTATUS_SELLADOS = ["En análisis", "Autorizado", "Contratado", "Dispersado"];

// «Autorizada» == «Autorizado»: sin acentos, sin género y en minúsculas.
const normEstatus = (v) => {
  const t = String(v || "").trim().toLowerCase()
    .replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i")
    .replace(/ó/g, "o").replace(/ú/g, "u");
  return /[oa]$/.test(t) ? t.slice(0, -1) : t;
};
const SELLADOS_NORM = ESTATUS_SELLADOS.map(normEstatus);

export const selladaPorEstatus = (s) => SELLADOS_NORM.includes(normEstatus(s?.estatus));

export const estaSellada = (s) =>
  String(s?.sello?.estado || "") === "sellada" || selladaPorEstatus(s);

export const estaCancelada = (s) =>
  String(s?.estatus || "") === "Cancelado" || !!s?.cancelado;

// sep-2026 · auditoría de alineación: el dinero ya entregado se lee del CRÉDITO real
// (`credito_desembolsado`, bandera derivada que expone el backend), nunca del texto del
// estatus. Una solicitud desalineada («Contratado» o «Autorizado» con el crédito ya
// desembolsado) seguía ofreciendo «Cancelar» sobre dinero que ya salió.
export const estaDesembolsada = (s) =>
  String(s?.estatus || "") === "Dispersado" || !!s?.credito_desembolsado;

// Etapa REAL del proceso: si el crédito ya está desembolsado, la verdad del crédito manda
// sobre el estatus guardado en la solicitud.
export const estatusEfectivo = (s) =>
  s?.credito_desembolsado && !estaCancelada(s) ? "Dispersado" : String(s?.estatus || "");

// Etapas del proceso, como las ve el usuario. El estatus es automático: lo mueven las
// acciones del flujo. «En análisis» es el nombre interno del estatus; en pantalla se
// muestra como «Enviada al Comité», que es lo que realmente pasó (decisión del PO).
export const ETIQUETA_ESTATUS = {
  "": "Captura",
  Prospecto: "Captura",
  Recibida: "Captura",
  Captura: "Captura",
  "En análisis": "Enviada al Comité",
  Autorizada: "Autorizado",
  Autorizado: "Autorizado",
  Rechazado: "Rechazado",
  Contratado: "Contratado",
  Dispersado: "Dispersado",
  Cancelado: "Cancelado",
};

export const etiquetaEstatus = (estatus) =>
  ETIQUETA_ESTATUS[String(estatus || "")] || String(estatus || "Captura");

export const esPendienteComite = (s) =>
  !s?.estatus || ESTATUS_PENDIENTES.includes(String(s.estatus));

// Una solicitud cancelada se conserva como evidencia: ni sus condiciones ni su estatus
// se editan. El ESTATUS nunca se teclea: lo mueve el flujo (Comité, contratar, desembolso).
export const camposSelladosDe = (s) => {
  if (estaCancelada(s) || estaSellada(s)) return [...CAMPOS_SELLADOS, "estatus"];
  return [];
};
